<template>
  <Transition name="slide-up">
    <div v-if="visible" class="device-recording-widget" role="status" aria-live="polite">
      <div class="widget-content">
        <div class="widget-icon">
          <span class="recording-pulse" />
          <w-icon name="microphone" size="medium" color="#fff" />
        </div>
        <div class="widget-text">
          <w-text type="bodyEmphasis" class="widget-title"> Gravando no celular </w-text>
          <w-text type="caption" class="widget-subtitle">
            A gravação está em andamento no seu dispositivo móvel.
          </w-text>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
/**
 * AIAssistantDeviceRecordingWidget.vue
 *
 * Floating widget that appears when a "recording" webhook is received
 * while the state machine is in "device_selection" or "idle".
 *
 * This notifies the user that recording has started on their mobile device
 * (e.g., after scanning the QR code).
 */
defineProps<{
  visible: boolean;
}>();
</script>

<style scoped lang="scss">
@import "style-variables.scss";

.device-recording-widget {
  position: fixed;
  bottom: 100px;
  right: 30px;
  z-index: 999999998;
  display: flex;
  align-items: center;
  min-width: 280px;
  max-width: 380px;
  background: #fff;
  border: 1.5px solid $primary-color;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
  padding: 14px 18px;
  font-family: inherit;
}

.widget-content {
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
}

.widget-icon {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  min-width: 40px;
  border-radius: 50%;
  background: $primary-color;
}

.recording-pulse {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background: $primary-color;
  animation: pulse-ring 1.8s ease-in-out infinite;
}

@keyframes pulse-ring {
  0% {
    transform: scale(1);
    opacity: 0.6;
  }
  70% {
    transform: scale(1.5);
    opacity: 0;
  }
  100% {
    transform: scale(1.5);
    opacity: 0;
  }
}

.widget-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.widget-title {
  color: $primary-color-dark;
  font-size: 14px;
  line-height: 1.3;
}

.widget-subtitle {
  color: var(--w-text-color-tertiary, #6b7280);
  font-size: 12px;
  line-height: 1.4;
  opacity: 0.85;
}

/* Slide-up transition */
.slide-up-enter-active {
  transition: all 0.35s cubic-bezier(0.22, 1, 0.36, 1);
}

.slide-up-leave-active {
  transition: all 0.25s cubic-bezier(0.4, 0, 1, 1);
}

.slide-up-enter-from {
  opacity: 0;
  transform: translateY(20px);
}

.slide-up-leave-to {
  opacity: 0;
  transform: translateY(20px);
}
</style>
